<template>
  <van-popup
    v-model:show="show"
    position="bottom"
    round
    closeable
    @close="handleClose"
    teleport="body"
  >
    <div class="ios-install-guide">
      <!-- 头部标题 -->
      <div class="header">
        <h3 class="title">{{ t('iosInstall.title') }}</h3>
      </div>

      <!-- 应用信息卡片 -->
      <div class="app-info-card">
        <div class="app-icon">
          <img :src="getAssetsFile('logo2.png')" alt="Suer Win Ph" class="icon" />
        </div>
        <div class="app-details">
          <h4 class="app-name">{{ props.appName }}</h4>
          <p class="app-url">{{ props.appUrl }}</p>
        </div>
      </div>

      <!-- 安装步骤 -->
      <div class="install-steps">

        <!-- 步骤1 -->
        <div class="step-item">
          <div class="step-number">1.</div>
          <div class="step-content">
            <p class="step-text">{{ t('iosInstall.step1.text1') }}</p>
            <div class="step-icon">
              <!-- <van-icon name="share-o" size="20" color="#1989fa" /> -->
               <img src="@/assets/images/up.png" alt="" width="18px">
            </div>
            <p class="step-text">{{ t('iosInstall.step1.text2') }}</p>
          </div>
        </div>

        <!-- 步骤2 -->
        <div class="step-item">
          <div class="step-number">2.</div>
          <div class="step-content">
            <p class="step-text">{{ t('iosInstall.step2.text1') }}</p>
            <div class="add-button">
            {{ t('iosInstall.addToHomeScreen') }}
            </div>
          </div>
        </div>

        <!-- 步骤3 -->
        <div class="step-item">
          <div class="step-number">3.</div>
          <div class="step-content">
            <p class="step-text">{{ t('iosInstall.step3.text1') }}</p>
            <div class="step-button">
              <img :src="getAssetsFile('logo2.png')" alt="Suer Win Ph" class="icon" width="20px"/>
            </div>
            <p class="step-text">{{ t('iosInstall.step3.text2') }}</p>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'

interface Props {
  modelValue: boolean
  appName?: string
  appUrl?: string
  appIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
  appName: 'Suer Win Ph',
  appUrl: 'Suer Win Ph.h21.com',
  appIcon: 'logo.png'
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'close': []
}>()

const { t } = useI18n()

const show = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const handleClose = () => {
  emit('close')
  show.value = false
}
</script>

<style scoped lang="less">
.ios-install-guide {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;

  .header {
    margin-bottom: 20px;

    .title {
      font-size: 14px;
      font-weight: 600;
      color: #000;
      margin: 0;
      line-height: 30px;
    }
  }

  .app-info-card {
    display: flex;
    align-items: center;
    // background: #f7f8fa;
    border: 2px solid #E5E5E5;
    border-style: dashed;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 24px;

    .app-icon {
      margin-right: 12px;

      .icon {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        object-fit: cover;
      }
    }

    .app-details {
      flex: 1;

      .app-name {
        font-size: 16px;
        font-weight: bold;
        color: #323233;
        margin: 0 0 4px 0;
      }

      .app-url {
        font-size: 14px;
        color: #969799;
        margin: 0;
      }
    }
  }

  .install-steps {
    flex: 1;
    // margin-bottom: 20px;

    .steps-title {
      font-size: 16px;
      font-weight: bold;
      color: #323233;
      margin: 0 0 16px 0;
    }

    .step-item {
      display: flex;
      align-items: center;
      // justify-content: center;
      margin-bottom: 20px;

      .step-number {
        width: 24px;
        height: 24px;
        // background: #1989fa;
        color: #000;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .step-content {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;

        .step-text {
          font-size: 14px;
          color: #323233;
          margin: 0;
        }

        .step-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          background: #f7f8fa;
          border-radius: 6px;
        }


        .add-button {
          border: 2px solid #E5E5E5;
          border-style: dashed;
          border-radius: 4px 6px;
          padding: 4px;
          color: #323233;
          font-size: 14px;
        }

      }
    }
  }

  .bottom-actions {
    padding-top: 16px;
    border-top: 1px solid #ebedf0;
  }
}
</style>
